var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.522 9.696V21H1V3.609h9.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.696 14.783 7.478 17.26l.522-4L12.74 5l2.695 1.565zM16.74 1.217c.738.435 1 1.392.564 2.13l-.913 1.61-2.695-1.566.956-1.652c.391-.696 1.348-.956 2.087-.522Z"
  }))));
};
export default SvgEdit;